const base = {
    get() {
        return {
            url : "http://ht.yiminkangjian.top/taoziyiyuan/",
            // url : "https://3oy553lz9754.vicp.fun/taoziyiyuan/",
            name: "taoziyiyuan",
        };
    },
    getProjectName(){
        return {
            projectName: "药当先hiv2小时阻断"
        } 
    }
}
export default base
